import type { GesperrteKachel, Schnellwahl } from '../schnellwahl';
import { formatiereEuro } from '../warenkorb';

/** Artikelnummer als Unterscheidung gleichnamiger Artikel (nur wenn gepflegt). */
function nummer(k: Schnellwahl): string {
  return k.artikelnummer === undefined ? '' : ` (Nr. ${k.artikelnummer})`;
}

/**
 * Mehrere Artikel zu einem gescannten Code (z. B. gleiche EAN bei zwei Größen, Barcode des
 * einen = Artikelnummer des anderen, dieselbe GTIN als UPC-A und EAN-13): die Kassierkraft
 * wählt, nie wird still der erste genommen. Gesperrte Artikel zum selben Code stehen mit Grund
 * dabei und sind nicht wählbar (PB-1).
 */
export function ScanAuswahlDialog(props: {
  code: string;
  treffer: readonly Schnellwahl[];
  gesperrt?: readonly GesperrteKachel[];
  onWahl: (k: Schnellwahl | null) => void;
}) {
  const gesperrt = props.gesperrt ?? [];
  return (
    <div className="zahlung-dialog" role="dialog" aria-modal="true" aria-label="Artikel wählen">
      <div className="karte">
        <h2>Welcher Artikel?</h2>
        <p className="hinweis">Code {props.code} gehört zu mehreren Artikeln.</p>
        <div className="chips" role="group" aria-label="Artikel zum Code">
          {props.treffer.map((k, i) => (
            <button
              key={`${String(i)}-${k.bezeichnung}`}
              type="button"
              onClick={() => {
                props.onWahl(k);
              }}
            >
              {k.bezeichnung}
              {nummer(k)} · {formatiereEuro(k.bruttoCent)} €
            </button>
          ))}
          {gesperrt.map((k, i) => (
            <button
              key={`gesperrt-${String(i)}-${k.bezeichnung}`}
              type="button"
              disabled
              title={`Nicht verkaufbar: ${k.grund}`}
            >
              {k.bezeichnung}
              {nummer(k)} – gesperrt: {k.grund}
            </button>
          ))}
        </div>
        <div className="zeile">
          <button
            type="button"
            className="taste zweit"
            onClick={() => {
              props.onWahl(null);
            }}
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
}
